import { Box, Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { forwardRef } from 'react'
import Chip from 'ui/Element/Text/Chip'
import Text from 'ui/Element/Text'
import { getSubLabel } from 'lib/util/string'

const styles = theme => ({
  option: {
    gap: '0.75rem',
  },
  subLabel: {
    gap: '0.25rem',
    flexWrap: 'nowrap',
  },
  text: {
    ...theme.typography['14/medium'],
    '& strong': {
      backgroundColor: theme.palette.success[50],
    },
  },
})

/**
 * Displays the name of a doc chunk.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellDashboardDocChunkName = (classes, props = {}) => {
  const {
    more = 0,
    label = '-',
    product, highlights: { content = [] },
    mentionsLabel: mentions = 'Mentions',
  } = props

  const ForwardedChip = forwardRef((chipProps, ref) => <Chip forwardedRef={ref} {...chipProps} />)
  const productLabels = product.map((item, index) => (
    <ForwardedChip
      key={index}
      value={item}
      size={'tiny'}
      color={'pending.700'}
      backgroundColor={'pending.50'}
    />
  ))

  return (
    <Grid
      container
      direction={'row'}
      flexWrap={'nowrap'}
      className={classes.option}
    >
      <Grid
        item
        xs={'auto'}
        sx={{ flexShrink: '1!important' }}
      >
        <Grid
          container
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}
        >
          <Text
            maxLines={1}
            value={label}
            variant={'14/bold'}
            color={'black.main'}
          />
          <Text
            maxLines={more > 0 ? 1 : 2}
            {...content?.[0] ? {
              component: 'div',
            } : {
              value: label,
            } }
            variant={'14/bold'}
            color={'black.main'}
          >
            {content?.[0] && <Box
              className={classes.text}
              dangerouslySetInnerHTML={{ __html: content[0] }}
            />}
          </Text>
          {productLabels?.length && (
            <Grid
              item
              container
              xs={'auto'}
              className={classes.subLabel}
            >
              {productLabels}
            </Grid>
          )}
          {more > 0 && (
            <Grid
              item
              container
              xs={'auto'}
              className={classes.subLabel}
              sx={{ marginTop: '0.25rem' }}
            >
              {getSubLabel(Text, [`+${more} ${mentions}`, <Text color={'black.main'} variant={'12/medium'} value={`"${label}"`}/>], ' ', { component: 'div' })}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellDashboardDocChunkName, styles)
